import { CSSProperties } from 'react';
import styles from './index.module.css';

export const MagnifyIcon = ({ style }: { style?: CSSProperties }) => (
  <div className={styles.magnify} style={style}></div>
);
